import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-restaurantstyle2',
  templateUrl: './restaurantstyle2.component.html',
  styleUrls: ['./restaurantstyle2.component.css']
})
export class Restaurantstyle2Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
